<div class="w-100">
  <h6 class="text-uppercase text-disabled mt-4">Helpful Materials</h6>
  <ul class="list-group list-group-flush">
    @for (action of actions; track $index) {
    <li class="list-group-item px-0">
      <a (click)="actionClick(action, $index)" class="pointer">
        <nb-icon
          [icon]="action.icon"
          status="primary"
          pack="mirasee"
          class="me-2"
        ></nb-icon
        >{{ action.text }}
      </a>
    </li>
    }
  </ul>
</div>
